import { CategoryErt, Role } from '../types/model';
import React, { FunctionComponent } from 'react';

import { AccountInfo } from '@azure/msal-browser';
import { Checkbox } from '../components/InputTypes/Checkbox';
import { Field } from 'redux-form';
import { RootState } from '../types/state';
import { checkPermission } from '../helpers/permissionHelper';
import { connect } from 'react-redux';

interface ErtComponentProps {
    maxColumnWidth?: number;
    maxItemsPerColumn?: number;
    title: string;
    color: string;
    categoryErts: CategoryErt[]
}

interface StoreProps {
    profile: AccountInfo | undefined;
}

const mapStateToProps = (state: RootState): StoreProps => {
    return ({
        profile: state.profile
    })
}

type Props = ReturnType<typeof mapStateToProps> & ErtComponentProps;

const ERTComponent: FunctionComponent<Props> = ({ title, maxColumnWidth, maxItemsPerColumn, color, categoryErts, profile }) => {
    var parentColumns = [] as JSX.Element[];
    var columns = [] as JSX.Element[];

    const buildErtFields = (erts: CategoryErt['erts']) => erts.map(e => {
        var name = e.ert;
        if (!Number.isNaN(+e.ert))
            name = e.brand + e.ert
        else if (e.ert.includes("/"))
            name = e.brand + e.ert.replace('/', "and");
        var reduxName = `erts.${name.charAt(0).toLocaleLowerCase() + name.slice(1)}`;
        return (
            <Field
                key={Math.random()}
                component={Checkbox}
                customClassLabel="ert-label"
                readOnly={!checkPermission(profile, Role.SuperUser)}
                name={reduxName}
                label={e.ert}
            />
        );
    });

    const flushColumns = () => {
        parentColumns.push(<div key={Math.random()} className="columns is-multiline is-variable is-4"> {columns} </div>);
        columns = [];
    };

    categoryErts.forEach((ce, i) => {
        if (i > 0 && i % (maxColumnWidth ? maxColumnWidth : Infinity) === 0) {
            flushColumns();
        }

        if (maxItemsPerColumn && ce.erts.length > maxItemsPerColumn) {
            // Split the category's erts into chunks of maxItemsPerColumn
            for (let chunk = 0; chunk < ce.erts.length; chunk += maxItemsPerColumn) {
                const isFirstChunk = chunk === 0;
                const slice = ce.erts.slice(chunk, chunk + maxItemsPerColumn);
                columns.push(
                    <div key={i * 100 + chunk} className="column is-narrow">
                        {isFirstChunk
                            ? <span className="ert-category-header" style={{ color }}>{ce.category}</span>
                            : <div className="ert-category-header-spacer" />}
                        {buildErtFields(slice)}
                    </div>
                );
            }
        } else {
            columns.push(
                <div key={i * 2} className="column is-narrow">
                    <span key={Math.random()} className="ert-category-header" style={{ color }}>{ce.category}</span>
                    {buildErtFields(ce.erts)}
                </div>
            );
        }

        if (categoryErts.length === i + 1)
            flushColumns();
    });

    if (!categoryErts || categoryErts.length === 0)
        return null;

    return (
        <div className="ert-container">
            <div className="columns">
                <div className="column ert-header" style={{ color: color }}>
                    {title}
                </div>
            </div>
            {parentColumns}
        </div>
    );
}

export default connect(mapStateToProps, {})(ERTComponent)

